import { fetch, Method, getPaging } from 'core/api/fetch';

const CostRoutes = {
    getList: (options) => `/api/v1.1.1/admin/cost?${options?.name?.length > 0 ? `name=${options.name}&` : ''}${options?.type ? `type=${options.type}&` : ''}${getPaging(options)}`,
    get: (costId) => `/api/v1.1.1/admin/cost/${costId}`,
    post: '/api/v1.1.1/admin/cost',
    patch: (costId) => `/api/v1.1.1/admin/cost/${costId}`,

    // Routes by cost entity
    getByEntity: (entity, id) => `/api/v1.1.1/admin/cost/${entity}cost/${id}`,
    postByEntity: (entity) => `/api/v1.1.1/admin/cost/${entity}cost`,
    patchByEntity: (entity, id) => `/api/v1.1.1/admin/cost/${entity}cost/${id}`,
    deleteByEntity: (entity, id) => `/api/v1.1.1/admin/cost/${entity}cost/${id}`,
};

const validateEntity = (entity) => {
    const validEntities = ['experience', 'experiencer', 'contract'];
    if (!entity || !validEntities.includes(entity)) {
        throw new Error('Invalid Entity');
    }
};

export const CostService = {
    getList: async (options) => {
        try {
            if (options?.type === 'all') {
                options.type = null;
            }

            const { data } = await fetch(CostRoutes.getList(options), {
                method: Method.GET,
                authenticated: true,
            });
            return !data
                ? { costs: [], total: 0, costCounts: null }
                : {
                      total: data.total,
                      costs: data.costs,
                      costCounts: data?.costsTotals[0],
                  };
        } catch (error) {
            throw new Error(error);
        }
    },
    get: async (costId) => {
        try {
            const { data } = await fetch(CostRoutes.get(costId), {
                method: Method.GET,
                authenticated: true,
            });
            return !data?.length ? null : data[0];
        } catch (error) {
            throw new Error(error);
        }
    },
    postCost: async (values) => {
        try {
            const { data } = await fetch(CostRoutes.post, {
                method: Method.POST,
                authenticated: true,
                data: values,
            });

            return data;
        } catch (error) {
            throw new Error(error);
        }
    },
    updateCost: async (costId, values) => {
        try {
            const { data } = await fetch(CostRoutes.patch(costId), {
                method: Method.PATCH,
                authenticated: true,
                data: values,
            });

            return data;
        } catch (error) {
            throw new Error(error);
        }
    },

    // Functions by Cost Entity
    getByEntity: async (entity, id) => {
        try {
            validateEntity(entity);
            const { data } = await fetch(CostRoutes.getByEntity(entity, id), {
                method: Method.GET,
                authenticated: true,
            });

            return data?.cost;
        } catch (error) {
            throw new Error(error);
        }
    },

    postCostByEntity: async (entity, values) => {
        try {
            validateEntity(entity);
            const { data } = await fetch(CostRoutes.postByEntity(entity), {
                method: Method.POST,
                authenticated: true,
                data: values,
            });

            return data;
        } catch (error) {
            throw new Error(error);
        }
    },

    updateCostByEntity: async (entity, id, values) => {
        try {
            const { data } = await fetch(CostRoutes.patchByEntity(entity, id), {
                method: Method.PATCH,
                authenticated: true,
                data: values,
            });

            return data;
        } catch (error) {
            throw new Error(error);
        }
    },

    deleteCostByEntity: async (entity, id) => {
        try {
            const { data } = await fetch(CostRoutes.deleteByEntity(entity, id), {
                method: Method.DELETE,
                authenticated: true,
            });

            return data;
        } catch (error) {
            throw new Error(error);
        }
    },
};
